<template>
  <div class="topic-edit">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px" size="small">
      <div class="white-container">
        <el-form-item label="标题" prop="name" style="width: 500px">
          <el-input v-model="form.name" placeholder="请输入训练营标题，最多不超过14个字符" maxlength="14" :disabled="disabled" />
        </el-form-item>
        <el-form-item label="训练营日期" prop="time" style="width: 500px">
          <el-date-picker v-model="form.time" type="daterange" value-format="yyyy-MM-dd" prefix-icon="el-icon-date" start-placeholder="训练营开始日期" end-placeholder="训练营结束日期" @change="hanldeTimeChange" />
        </el-form-item>
        <el-form-item label="营期任务" prop="taskList">
          <TaskList ref="taskList" :days-list="daysList" :task-data="taskData" @change="handleTaskChange" />
        </el-form-item>
        <el-form-item label="报名截止时间" prop="differDay" style="width: 500px">
          <div class="flex tips">活动开始前
            <el-input v-model="form.differDay" type="number" :min="0" :disabled="disabled" style="width:50px !important;margin: 0 10px" oninput="value=value.replace('/^[1-9]\d*$/','')" @keydown.native="handleFixNaN" />天
          </div>
        </el-form-item>
        <el-form-item label="训练营教练" prop="coachSelectVO" style="width: 100%">
          <CampSelect v-model="form.coachSelectVO" :value.sync="form.coachSelectVO" />
        </el-form-item>
        <el-form-item label="建议人数" prop="suggestedNumberOfPeople" style="width:300px">
          <el-input v-model.number="form.suggestedNumberOfPeople" type="number" placeholder="请输入参与人数" maxlength="9" @input="value => form.suggestedNumberOfPeople = parseInt(value)" />
        </el-form-item>

        <el-form-item label="运动目标" prop="movingTarget" style="width:300px">
          <el-select v-model="form.movingTarget" placeholder="请选择运动目标" multiple :disabled="disabled">
            <el-option v-for="item in movingSelectVO" :key="item.id" :label="item.tagName" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="训练营介绍" prop="content" style="width: 100%">
          <el-input v-model="form.content" type="textarea" placeholder="请输入训练营介绍" :disabled="disabled" />
        </el-form-item>
        <el-form-item label="注意事项" prop="announcement" style="width: 100%">
          <el-input v-model="form.announcement" type="textarea" placeholder="请输入注意事项" :disabled="disabled" />
        </el-form-item>
      </div>
      <div class="white-container marginTop">
        <el-form-item label="上传图片" prop="converImage" class="image-config">
          <div class="flex uploadImg-cont">
            <UploadImage :url="form.converImage.recommendedPicturesOfHomeCamp" title="首页训练营图片" size-tips="686px*240px" :save-path="savePath" :disabled="disabled" @upload="uploader($event,'recommendedPicturesOfHomeCamp')" @triggerReg="handleCheckReg" />
            <UploadImage :url="form.converImage.campListPagePicture" title="训练营列表页图片" size-tips="280px*310px" :save-path="savePath" :disabled="disabled" @upload="uploader($event,'campListPagePicture')" @triggerReg="handleCheckReg" />
            <UploadImage :url="form.converImage.campDetailsPageHeader" title="训练营详情页头图" size-tips="750px*370px" :save-path="savePath" :disabled="disabled" @upload="uploader($event,'campDetailsPageHeader')" @triggerReg="handleCheckReg" />
            <UploadImage :url="form.converImage.myCampListPictures" title="我的训练营列表页图片" size-tips="162px*180px" :save-path="savePath" :disabled="disabled" @upload="uploader($event,'myCampListPictures')" @triggerReg="handleCheckReg" />
            <UploadImage :url="form.converImage.shareCardImage" title="小程序分享卡片" size-tips="500px*400px" :limit-size="2" :save-path="savePath" :disabled="disabled" @upload="uploader($event,'shareCardImage')" @triggerReg="handleCheckReg" />
            <UploadImage :url="form.converImage.shareImage" title="训练营长图分享图片" size-tips="676px*742px" :save-path="savePath" :disabled="disabled" @upload="uploader($event,'shareImage')" @triggerReg="handleCheckReg" />
          </div>
        </el-form-item>
      </div>
      <div class="white-container marginTop">
        <el-form-item label="关联商品配置" prop="files" class="product-config">
          <Product :products="form.recommendEquipments" :save-path="savePath" :disabled="disabled" @updateProducts="updateProducts" />
        </el-form-item>
        <el-form-item style="width:100%;margin-top:80px;margin-left:-50px">
          <div class="flex btns">
            <el-button type="info" @click="cancel">取消</el-button>
            <el-button type="primary" @click="submit">保存</el-button>
          </div>
        </el-form-item>
      </div>
    </el-form>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import { Camp } from '@/model/Camp';
import Product from '@/components/Product';
import UploadImage from '@/components/UploadImage';
import Dialog from '@/components/Dialog';
import { filterCoach } from '@/filters';
import CampSelect from "./select.vue";
import TaskList from './taskList.vue';
import {
  getCampDetails,
  postCampAdd,
  postCampEdit,
} from '@/api/camp';
import { createTaskClock, updateTaskClock } from '@/api/taskClock';
export default {
  components: { Product, UploadImage, Dialog, CampSelect, TaskList },
  data() {
    const checkCampSelectVO = (rule, value, callback) => {
      if (value && value.length) {
        const ids = [];
        value.some((item) => {
          if (item.id && ids.includes(item['id'])) {
            callback(new Error('请选择不重复的训练营教练'));
          }
          ids.push(item['id']);
        });
      }
      callback();
    };
    return {
      form: new Camp(),
      rules: {
        name: [
          { required: true, message: '请输入训练营标题', trigger: 'blur' },
        ],
        time: [
          { type: 'array', required: true, message: '请选择训练营日期', trigger: 'change' },
        ],
        taskList: {
          required: true, validator: (rule, value, callback) => {
            if (Array.isArray(value)) {
              const length = value.reduce((pre, current) => {
                pre += current.course.length + current.uaEvent.length + current.taskBodyTestDetailsVOS.length + current.userDefinedTaskDetailVOS.length;
                return pre;
              }, 0);
              if (length === 0) {
                callback(new Error('请至少添加一个营期任务'));
              }
            }
            if (!value) {
              callback(new Error('请添加营期任务'));
            } else {
              callback();
            }
          }, trigger: ['blur', 'change'],
        },
        coachSelectVO: [
          { required: true, message: "请选择训练营教练", trigger: ["blur"] },
          { validator: checkCampSelectVO, trigger: 'change' },
        ],
        suggestedNumberOfPeople: [
          { required: true, message: '请输入参与人数', trigger: 'blur' },
        ],
        movingTarget: [
          { type: 'array', required: true, message: '请选择运动目标', trigger: 'change' },
        ],
        content: [
          { required: true, message: '请输入训练营介绍', trigger: 'blur' },
        ],
        announcement: [
          { required: true, message: '请输入注意事项', trigger: 'blur' },
        ],
        converImage: {
          required: true, validator: (rule, value, callback) => {
            const array = [];
            for (const key in value) {
              array.push(value[key]);
            }
            if (array.length !== 6 || array.some((item) => !item)) {
              callback(new Error('请上传图片'));
            } else {
              callback();
            }
          }, trigger: ['change'],
        },
      },
      coachList: [],
      savePath: 'online_activity/camp/detail/',
      formDialogShow: false,
      information: {},
      uploadedFile: false,
      choozeOther: false,
      cancelText: '',
      taskData: [],
      daysList: [],
      taskType: 'add', // 训练营打卡任务走新增方法还是编辑方法
    };
  },

  computed: {
    ...mapState('camp',
      [
        'coachSelectVO',
        'movingSelectVO',
      ]),
    name() {
      return function (item) {
        return item.firstName + item.lastName;
      };
    },
    disabled() {
      // return [0, 2, 4].indexOf(this.form.status) !== -1;
      return false;
    },
  },
  async mounted() {
    await this.getSelect();
    const { query } = this.$route;
    const id = query.id || query.copyid;
    if ((!query.copyid && !query.id) || query.copyid) {
      this.taskType = 'add';
    } else {
      this.taskType = 'edit';
    }
    if (query.id || query.copyid) {
      this.fetchDetails(id);
      await this.fetchTaskList(id);
    }
    this.cancelText = query.id ? '编辑' : '新增';
  },
  methods: {
    ...mapActions('camp', ['getSelect']),
    hanldeTimeChange(value) {
      this.taskData = [];
      this.dealTime();
    },
    dealTime() {
      const [start, end] = this.form.time;
      this.daysList = [];
      if (!start || !end) return;
      if (start && end && start === end) {
        this.daysList = [this.$moment(start).format("YYYY.MM.DD")];
      } else {
        const SDate = this.$moment(start);
        const EDate = this.$moment(end);
        this.daysList.push(SDate.format("YYYY.MM.DD"));
        while (SDate.add(1, "days").isBefore(EDate)) {
          // 注意这里add方法处理后SDate对象已经改变。
          this.daysList.push(SDate.format("YYYY.MM.DD"));
        }
        this.daysList.push(EDate.format("YYYY.MM.DD"));
      }
    },
    handleTaskChange(data) {
      this.form.taskList = data;
      this.$refs.form.validateField("taskList");
    },
    // 获取打卡任务列表
    fetchTaskList(id) {
      this.$Api.taskClock.getTaskList(7, id).then(res => {
        this.taskData = res;
      });
    },
    handleCheckReg() {
      this.$refs.form.validateField("converImage");
    },
    handleFixNaN(e) {
      const { key } = e;
      if (key === 'e' || key === '.') {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    fetchDetails(id) {
      getCampDetails(id)
        .then((data) => {
          if (data.coachSelectVO && this.coachSelectVO && this.coachSelectVO.length) {
            this.coachList = filterCoach(this.coachSelectVO, data.coachSelectVO.level);
          }
          this.form = new Camp(data);
          this.dealTime();
        });
    },

    submit() {
      this.formDialogShow = true;
      this.information = {
        operation: "submit",
        icon: "warn",
        subTitle: "请注意训练营状态，保存后已发布的训练营信息将实时更新至UA HOUSE小程序",
      };
    },
    dealTaskActivity(id) {
      const data = {
        objectType: 7,
        objectId: id,
      };
      const list = [];
      this.form.taskList.forEach(item => {
        if (item.course.length === 0 && item.uaEvent.length === 0 && item.userDefinedTaskDetailVOS.length === 0 && item.taskBodyTestDetailsVOS.length === 0) {
          console.info('这一天没有任务');
        } else {
          list.push({
            courseId: item.course.map(c => c.id),
            day: item.day,
            uaEventId: item.uaEvent.map(u => u.id),
            userDefinedTaskAddDTOS: item.userDefinedTaskDetailVOS || [],
            taskBodyTestAddDTOS: item.taskBodyTestDetailsVOS || [],
          });
        }
      });
      data['trainingCampTaskDTOS'] = list;
      return data;
    },
    addCamp() {
      if (this.$route.query.copyid) {
        this.form.id = '';
      }
      const param = { ...this.form };
      if (!this.form.id) delete param.id;
      param.coachId = [];
      param.coachSelectVO.forEach((item, index) => {
        item.id && param.coachId.push(item.id);
      });
      delete param.coachSelectVO;
      if (this.form.id) {
        postCampEdit(param).then((data) => {
          const taskParams = this.dealTaskActivity(this.form.id);
          updateTaskClock(taskParams).then(res => {
            this.$message.success('修改成功');
            setTimeout(() => {
              this.goBack();
            }, 2000);
          });
        });
      } else {
        postCampAdd(param).then((data) => {
          if (data) {
            const taskParams = this.dealTaskActivity(data);
            createTaskClock(taskParams).then(res => {
              this.$message.success('新增成功');
              setTimeout(() => {
                this.goBack();
              }, 2000);
            });
          }
        });
      }
    },

    uploader(file, key) {
      this.form.converImage[key] = file;
      this.$forceUpdate();
    },

    updateProducts(products) {
      this.form.recommendEquipments = products;
      this.$forceUpdate();
    },

    cancel() {
      this.formDialogShow = true;
      this.information = {
        operation: 'delete',
        icon: 'warn',
        subTitle: `是否放弃${this.cancelText}，返回上级页面？`,
      };
    },
    dialogSuccess() {
      if (this.information.operation && this.information.operation === 'delete') {
        this.goBack();
      } else if (this.information.operation && this.information.operation === 'submit') {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (Array.isArray(this.form.recommendEquipments)) {
              const isNotValid = this.form.recommendEquipments.filter((item) => {
                if (!item.imageUrl || !item.linkTo || !item.name) {
                  this.$message.error('请完善商品信息');
                  return true;
                } else {
                  return false;
                }
              });
              if (!isNotValid.length) {
                this.addCamp();
              }
            } else {
              this.addCamp();
            }
          } else {
            return false;
          }
        });
      }
    },
    goBack() {
      this.$router.back(-1);
    },
  },
};

</script>
<style lang="less" scoped>
.row-cont {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.btns {
  align-items: center;
  justify-content: center;
}
.marginTop {
  margin-top: 30px;
}
</style>
<style lang="less">
.topic-edit {
  .el-form-item--small.el-form-item {
    margin-bottom: 30px;
    .form-radio {
      line-height: 32px;
      height: 32px;
      align-items: center;
    }
    .coupon-uploader {
      margin: unset;
      display: flex;
      height: 34px;
      line-height: 34px;
      .el-button {
        width: 115px;
        height: 34px;
      }
      .coupon_tip {
        width: 250px;
        white-space: nowrap;
        margin-left: 10px;
        margin-right: 20px;
      }
      .download-file {
        white-space: nowrap;
      }
    }
  }
  .coach-select-box + .el-form-item__error {
    top: unset !important;
    bottom: 43px !important;
  }
  .uploadImg-cont {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .uploader {
      margin-bottom: 30px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
  .form-icon {
    margin-left: 10px;
    .el-icon-close {
      color: #9b9b9b;
      cursor: pointer;
      &:hover {
        color: #000000;
      }
    }
  }
  .btn-reset {
    margin-left: 10px;
    cursor: pointer;
    font-family: "Noto Sans SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #0085d0;
  }
  .form-add {
    margin-top: 24px;
    .el-button {
      border: 1px dashed #bbbbbb;
      i {
        color: #bbbbbb;
      }
      span {
        color: #bbbbbb;
      }
    }
  }
  .product-config,
  .image-config {
    .el-form-item__label {
      float: none;
    }
    .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  .lng-label .el-form-item__label {
    width: 50px !important;
  }
  .lng-label .el-form-item__content {
    margin-left: 50px !important;
  }
  .btn-form-item.el-form-item--small {
    .el-form-item__content {
      margin-left: 0 !important;
    }
  }
}
</style>

